import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Card, Row, Col, Form, Input,
	InputNumber, Button, message, Alert, Switch,
	Typography, DatePicker, Select, Spin, Divider,
} from 'antd';
import {
	CloseCircleOutlined, SettingOutlined, ArrowLeftOutlined,
	GiftOutlined, SaveOutlined, EditOutlined, PlusCircleOutlined,
	CalendarOutlined, TagOutlined, PercentageOutlined,
	FileTextOutlined, AppstoreOutlined, ControlOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import Config from '../../Config';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig, extractResult } from '../../store/actions';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Reward Tepat Waktu',
	apiUrl: {
		preview: 'master/api/reward-diskon/',
		layanan: 'master/api/layanan/',
	},
	pageUrl: { data: '/admin/pengaturan/reward-tepat-waktu/' },
	breadCrumb: [
		<span><SettingOutlined /> Pengaturan</span>,
		<Link to="/admin/pengaturan/reward-tepat-waktu">Reward Tepat Waktu</Link>,
		'Form',
	],
};

const config = new Config();

const FIELD_STYLE = { borderRadius: 8, height: 38 };

class FormRewardDiskon extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			isRedirect: false,
			errTitle: '',
			errMsg: '',
			loadingButton: false,
			aksi: 'tambah',
			method: 'post',
			idLama: '',
			is_aktif: true,
			loadingLayanan: null,
			listLayanan: [],
			isMobile: window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.loadLayanan();
		if (this.props.match.params.id !== undefined) {
			this.preview(this.props.match.params.id);
		}
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	loadLayanan(url = null, isSearch = false) {
		const endpoint = url || configClass.apiUrl.layanan;
		const stateProgressName = isSearch ? 'loadingLayanan_searching' : 'loadingLayanan';
		this.setState({ [stateProgressName]: true });
		this.props.ajaxViewHandler('get', endpoint)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					if (data.count !== undefined) {
						const old = this.state.listLayanan;
						this.setState({
							listLayanan: (old.length === 0 || isSearch)
								? data
								: { ...data, results: [...old.results, ...data.results] },
						});
					} else {
						this.setState({ listLayanan: data });
					}
				}
				this.setState({ [stateProgressName]: false });
			});
	}

	generateMultiSelect() {
		const { loadingLayanan, listLayanan } = this.state;
		if (loadingLayanan === true) {
			return <Select disabled placeholder="Memuat..." loading style={{ borderRadius: 8 }} />;
		}
		const items = listLayanan.count !== undefined
			? listLayanan.results
			: (Array.isArray(listLayanan) ? listLayanan : []);
		return (
			<Select
				mode="multiple"
				showSearch
				placeholder="Pilih layanan..."
				optionFilterProp="children"
				onSearch={(val) => this.loadLayanan(configClass.apiUrl.layanan + '?search=' + val, true)}
				onPopupScroll={(e) => {
					e.persist();
					const t = e.target;
					if (t.scrollTop + t.offsetHeight === t.scrollHeight && listLayanan && listLayanan.next) {
						this.loadLayanan(listLayanan.next);
					}
				}}
				allowClear
				style={{ width: '100%', borderRadius: 8 }}
			>
				{this.state.loadingLayanan_searching && (
					<Select.Option value=""><Spin size="small" /></Select.Option>
				)}
				{items.map((item) => (
					<Select.Option key={item.id} value={item.id}>{item.nama}</Select.Option>
				))}
				{listLayanan && listLayanan.next && (
					<Select.Option value=""><Spin size="small" /></Select.Option>
				)}
			</Select>
		);
	}

	async preview(id) {
		message.loading({ content: 'Memuat data...', duration: 0, key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + id + '/')
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					this.formRef.current.setFieldsValue({
						...data,
						tanggal_mulai:   data.tanggal_mulai   ? moment(data.tanggal_mulai)   : null,
						tanggal_selesai: data.tanggal_selesai ? moment(data.tanggal_selesai) : null,
					});
					this.setState({ is_aktif: data.is_aktif, aksi: 'edit', method: 'put', idLama: id + '/' });
					message.destroy();
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: data });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
			}).catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	handleSubmit = (values) => {
		this.postData({
			...values,
			is_aktif:        this.state.is_aktif,
			tanggal_mulai:   values.tanggal_mulai   ? values.tanggal_mulai.format('DD-MM-YYYY')   : null,
			tanggal_selesai: values.tanggal_selesai ? values.tanggal_selesai.format('DD-MM-YYYY') : null,
		});
	};

	async postData(datas) {
		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.setState({ loadingButton: true });
		this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview + this.state.idLama, datas, false, true)
			.then((action) => {
				this.setState({ loadingButton: false });
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
					this.setState({ isRedirect: true });
				} else {
					const errTitle = 'Gagal menyimpan data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: responseMsg });
				}
			}).catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan jaringan, coba lagi', duration: 2, key: 'toast' });
			});
	}

	render() {
		if (this.state.isRedirect) return <Redirect to={configClass.pageUrl.data} />;

		const { loadingButton, errTitle, errMsg, aksi, is_aktif, isMobile } = this.state;
		const isEdit = aksi === 'edit';
		const pageTitle = isEdit ? 'Edit Reward Tepat Waktu' : 'Tambah Reward Tepat Waktu';
		const colSpan = isMobile ? 24 : 12;

		return (
			<div>
				<Helmet>
					<title>{pageTitle + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.form-reward-wrap .ant-form-item-label > label {
							font-weight: 600; color: #374151; font-size: 13px;
						}
						.form-reward-wrap .ant-input,
						.form-reward-wrap .ant-input-number,
						.form-reward-wrap .ant-input-number-group-wrapper,
						.form-reward-wrap .ant-picker,
						.form-reward-wrap .ant-select-selector {
							border-radius: 8px !important;
						}
						.form-reward-wrap .ant-input-number-group-wrapper .ant-input-number {
							border-radius: 8px 0 0 8px !important;
						}
						.form-reward-wrap .ant-input-number-group-addon {
							border-radius: 0 8px 8px 0 !important;
						}
						.form-reward-wrap .ant-input:focus,
						.form-reward-wrap .ant-input-number-focused,
						.form-reward-wrap .ant-picker-focused,
						.form-reward-wrap .ant-select-focused .ant-select-selector {
							border-color: #1e4d8a !important;
							box-shadow: 0 0 0 2px rgba(30,77,138,0.1) !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={!!errTitle}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Form
					ref={this.formRef}
					layout="vertical"
					onFinish={this.handleSubmit}
					className="form-reward-wrap"
					initialValues={{ hari_mulai: 0, is_aktif: true }}
				>
					<Card
						style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
						bodyStyle={{ padding: 0 }}
					>
						{/* Header */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex', alignItems: 'center', gap: 16,
						}}>
							<div style={{
								width: 52, height: 52, borderRadius: 14, flexShrink: 0,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex', alignItems: 'center', justifyContent: 'center',
							}}>
								{isEdit
									? <EditOutlined style={{ color: '#fff', fontSize: 24 }} />
									: <PlusCircleOutlined style={{ color: '#fff', fontSize: 24 }} />
								}
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>{pageTitle}</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, marginTop: 3 }}>
									{isEdit ? 'Ubah konfigurasi reward diskon tepat waktu' : 'Atur program reward untuk wajib pajak tepat waktu'}
								</div>
							</div>
							<Link to={configClass.pageUrl.data}>
								<Button
									icon={<ArrowLeftOutlined />}
									style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', borderRadius: 8, flexShrink: 0 }}
								>
									{!isMobile && 'Kembali'}
								</Button>
							</Link>
						</div>

						{/* Info Alert */}
						<div style={{ padding: '16px 24px 0' }}>
							<Alert
								message="Program Reward Tepat Waktu"
								description="Wajib pajak yang membayar PKB sebelum jatuh tempo sesuai rentang hari yang dikonfigurasi akan mendapatkan diskon sesuai persentase yang ditetapkan."
								type="info" showIcon style={{ borderRadius: 8 }}
							/>
						</div>

						{/* Section: Informasi Kategori */}
						<div style={{ padding: '16px 24px 4px' }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, paddingBottom: 10, borderBottom: '1.5px solid #d0dff5' }}>
								<TagOutlined style={{ color: '#1e4d8a', fontSize: 15 }} />
								<Text strong style={{ fontSize: 14, color: '#0f2847' }}>Informasi Kategori</Text>
							</div>

							<Form.Item
								label={<span><TagOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Nama Kategori</span>}
								name="nama"
								rules={[{ required: true, message: 'Nama kategori wajib diisi' }]}
							>
								<Input placeholder="Contoh: Kategori 1 / Tier Perak / dst" style={FIELD_STYLE} maxLength={100} />
							</Form.Item>

							<Row gutter={[16, 0]}>
								<Col span={colSpan}>
									<Form.Item
										label={<span><CalendarOutlined style={{ color: '#52c41a', marginRight: 6 }} />Tanggal Mulai Program</span>}
										name="tanggal_mulai"
										rules={[{ required: true, message: 'Tanggal mulai wajib diisi' }]}
										extra="Tanggal program reward mulai berlaku."
									>
										<DatePicker format="DD-MM-YYYY" style={{ width: '100%', borderRadius: 8 }} placeholder="Pilih tanggal mulai" />
									</Form.Item>
								</Col>
								<Col span={colSpan}>
									<Form.Item
										label={<span><CalendarOutlined style={{ color: '#f5222d', marginRight: 6 }} />Tanggal Selesai Program</span>}
										name="tanggal_selesai"
										rules={[
											{ required: true, message: 'Tanggal selesai wajib diisi' },
											({ getFieldValue }) => ({
												validator(_, value) {
													if (!value || !getFieldValue('tanggal_mulai')) return Promise.resolve();
													if (value.isSameOrAfter(getFieldValue('tanggal_mulai'), 'day')) return Promise.resolve();
													return Promise.reject(new Error('Tanggal selesai tidak boleh sebelum tanggal mulai'));
												},
											}),
										]}
										extra="Tanggal program reward berakhir."
									>
										<DatePicker format="DD-MM-YYYY" style={{ width: '100%', borderRadius: 8 }} placeholder="Pilih tanggal selesai" />
									</Form.Item>
								</Col>
							</Row>
						</div>

						{/* Section: Konfigurasi Reward */}
						<div style={{ padding: '4px 24px 4px' }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, paddingBottom: 10, borderBottom: '1.5px solid #d0dff5' }}>
								<PercentageOutlined style={{ color: '#1e4d8a', fontSize: 15 }} />
								<Text strong style={{ fontSize: 14, color: '#0f2847' }}>Konfigurasi Reward</Text>
							</div>

							<Row gutter={[16, 0]}>
								<Col span={colSpan}>
									<Form.Item
										label={<span><CalendarOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Hari Mulai (sebelum JT)</span>}
										name="hari_mulai"
										rules={[{ required: true, message: 'Hari mulai wajib diisi' }]}
										extra="Hari minimum sebelum jatuh tempo. Isi 0 jika mulai dari hari H."
									>
										<InputNumber min={0} max={365} addonAfter="hari" style={{ width: '100%', borderRadius: 8 }} />
									</Form.Item>
								</Col>
								<Col span={colSpan}>
									<Form.Item
										label={<span><CalendarOutlined style={{ color: '#722ed1', marginRight: 6 }} />Hari Sampai (sebelum JT)</span>}
										name="hari_sampai"
										rules={[
											{ required: true, message: 'Hari sampai wajib diisi' },
											({ getFieldValue }) => ({
												validator(_, value) {
													const mulai = getFieldValue('hari_mulai');
													if (!value || mulai === undefined || value >= mulai) return Promise.resolve();
													return Promise.reject(new Error('Hari sampai tidak boleh kurang dari hari mulai'));
												},
											}),
										]}
										extra="Hari maksimum sebelum jatuh tempo. Contoh: 30, 60, atau 90."
									>
										<InputNumber min={1} max={365} addonAfter="hari" style={{ width: '100%', borderRadius: 8 }} />
									</Form.Item>
								</Col>
								<Col span={colSpan}>
									<Form.Item
										label={<span><PercentageOutlined style={{ color: '#389e0d', marginRight: 6 }} />Persentase Diskon</span>}
										name="persentase"
										rules={[
											{ required: true, message: 'Persentase diskon wajib diisi' },
											{ validator(_, value) { if (!value || (value > 0 && value <= 100)) return Promise.resolve(); return Promise.reject(new Error('Persentase harus antara 0 dan 100')); } },
										]}
										extra="Besaran diskon. Contoh: 2 untuk 2%."
									>
										<InputNumber min={0} max={100} step={0.5} precision={2} addonAfter="%" style={{ width: '100%', borderRadius: 8 }} />
									</Form.Item>
								</Col>
								<Col span={colSpan}>
									<Form.Item
										label={<span><ControlOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Status Aktif</span>}
										extra="Nonaktifkan jika kategori reward ini tidak sedang berlaku."
									>
										<Switch
											checked={is_aktif}
											onChange={(val) => this.setState({ is_aktif: val })}
											checkedChildren="Aktif"
											unCheckedChildren="Nonaktif"
										/>
									</Form.Item>
								</Col>
							</Row>
						</div>

						{/* Section: Layanan */}
						<div style={{ padding: '4px 24px 4px' }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, paddingBottom: 10, borderBottom: '1.5px solid #d0dff5' }}>
								<AppstoreOutlined style={{ color: '#1e4d8a', fontSize: 15 }} />
								<Text strong style={{ fontSize: 14, color: '#0f2847' }}>Layanan</Text>
							</div>

							<Form.Item
								label={<span><AppstoreOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Layanan PKB</span>}
								name="layanan_array"
								rules={[{ required: true, message: 'Pilih minimal 1 layanan PKB' }]}
								extra="Layanan yang mendapat reward diskon PKB."
							>
								{this.generateMultiSelect()}
							</Form.Item>

							<Form.Item
								label={<span><AppstoreOutlined style={{ color: '#13c2c2', marginRight: 6 }} />Layanan SWDKLLJ</span>}
								name="layanan_swdkllj"
								rules={[{ required: true, message: 'Pilih minimal 1 layanan SWDKLLJ' }]}
								extra="Layanan yang mendapat reward diskon SWDKLLJ."
								style={{ marginBottom: 0 }}
							>
								{this.generateMultiSelect()}
							</Form.Item>
						</div>

						{/* Section: Keterangan */}
						<div style={{ padding: '16px 24px 20px' }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, paddingBottom: 10, borderBottom: '1.5px solid #d0dff5' }}>
								<FileTextOutlined style={{ color: '#1e4d8a', fontSize: 15 }} />
								<Text strong style={{ fontSize: 14, color: '#0f2847' }}>Keterangan</Text>
							</div>

							<Form.Item
								label={<span><FileTextOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Keterangan</span>}
								name="keterangan"
								style={{ marginBottom: 0 }}
							>
								<Input.TextArea
									rows={3}
									placeholder="Keterangan tambahan (opsional)"
									maxLength={500}
									showCount
									style={{ borderRadius: 8 }}
								/>
							</Form.Item>
						</div>

						{/* Footer */}
						<Divider style={{ margin: 0 }} />
						<div style={{
							padding: '16px 28px',
							display: 'flex', gap: 10,
							justifyContent: isMobile ? 'stretch' : 'flex-end',
							flexDirection: isMobile ? 'column' : 'row',
							background: '#fafafa',
						}}>
							<Link to={configClass.pageUrl.data} style={isMobile ? { display: 'block' } : {}}>
								<Button
									icon={<CloseCircleOutlined />}
									size="large"
									disabled={loadingButton}
									style={{ borderRadius: 10, ...(isMobile ? { width: '100%' } : {}) }}
								>
									Batal
								</Button>
							</Link>
							<Button
								type="primary"
								htmlType="submit"
								icon={<SaveOutlined />}
								size="large"
								loading={loadingButton}
								style={{
									borderRadius: 10,
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									border: 'none',
									fontWeight: 600,
									...(isMobile ? { width: '100%' } : {}),
								}}
							>
								{isEdit ? 'Simpan Perubahan' : 'Tambah Reward'}
							</Button>
						</div>
					</Card>
				</Form>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(FormRewardDiskon);
